import {DEFAULT_SIGHT_RADIUS_METERS} from "./SightRange.ts";

export const NEAR_SIGHT_RADIUS_METERS = 3;
export const PERIPHERAL_BRIGHTNESS = 0.5;
export const DARKVISION_BRIGHTNESS = 0.5;
export const SIGHT_CONE_HALF_ANGLE_DEGREES = 45;
export const SIGHT_CONE_BLEND_DEGREES = 5;

const clamp01 = (value: number) => Math.min(1, Math.max(0, value));
const cosine = (degrees: number) => Math.cos(degrees * Math.PI / 180);

export const TOKEN_CONE_MIN_COSINE = cosine(SIGHT_CONE_HALF_ANGLE_DEGREES);
export const CONE_BLEND_OUTER_COSINE = cosine(SIGHT_CONE_HALF_ANGLE_DEGREES + SIGHT_CONE_BLEND_DEGREES);
export const CONE_BLEND_INNER_COSINE = cosine(SIGHT_CONE_HALF_ANGLE_DEGREES - SIGHT_CONE_BLEND_DEGREES);

function smoothstep(start: number, end: number, value: number): number {
    const progress = clamp01((value - start) / (end - start));
    return progress * progress * (3 - 2 * progress);
}

export function radialVisibility(
    distanceMeters: number, radiusMeters = DEFAULT_SIGHT_RADIUS_METERS,
): number {
    return radiusMeters > 0 ? clamp01(1 - distanceMeters / radiusMeters) : 0;
}

export function fogBrightness(distanceMeters: number, radiusMeters: number, directionCosine: number): number {
    const ambient = PERIPHERAL_BRIGHTNESS * radialVisibility(distanceMeters, radiusMeters);
    const cone = radialVisibility(distanceMeters, radiusMeters) * smoothstep(
        CONE_BLEND_OUTER_COSINE, CONE_BLEND_INNER_COSINE, directionCosine,
    );
    return ambient + (1 - PERIPHERAL_BRIGHTNESS) * cone;
}
